import React, { useState, useEffect } from 'react';
import axiosInstance from "../../../api/api";
import { Button, Card, Form, Modal } from "@themesberg/react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import CardLayout from "../Layout/CardLayout";
import CiuuList from "../CiuuList/CiuuList";
import Ranked from "../Ciem/Ranked";

const ProductList = ({ ciemId }) => {
    const [product, setProduct] = useState(null);
    const [editingProductId, setEditingProductId] = useState(null);
    const [editedDescription, setEditedDescription] = useState('');
    const [tituloProduct, setTituloProduct] = useState([]);
    const [showModalInformacion, setShowModalInformacion] = useState(false);
    const [modalContentInformacion, setModalContentInformacion] = useState('');
    const [rankedForm, setRankedForm] = useState([]);

    const tabla = <CiuuList ciemId={ciemId} />;

    useEffect(() => {
        const fetchProduct = async () => {
            try {
                const response = await axiosInstance.get(`/ciem/${ciemId}`);
                const productData = response.data.data;
                setProduct(productData);
                setEditedDescription(productData.descriptionProduct || '');
                console.log(productData)

                const tituloProductResponse = await axiosInstance.get('/detailoption/option/value/product'); // Reemplaza con la URL de tu API de datos
                setTituloProduct(tituloProductResponse.data.data);

                const ranked = await axiosInstance.get('/detailoption/option/value/rankedTwo'); // Reemplaza con la URL de tu API de títulos
                const primerElemento = ranked.data;
                console.log("calificacion")
                console.log(primerElemento.data[0])// Asume que la API de títulos devuelve un array con un objeto y extrae las claves como títulos
                setRankedForm(primerElemento.data[0]);

            } catch (error) {
                console.error('Error fetching product:', error);
            }
        };

        if (ciemId) {
            fetchProduct();
        } else {
            setProduct(null);
        }
    }, [ciemId]);

    const handleEdit = (descriptionProduct) => {
        setEditingProductId(product.id);
        setEditedDescription(descriptionProduct);
    };

    const handleSave = async () => {
        try {
            await axiosInstance.patch(
                `/ciem/descriptionProduct/${product.id}`,
                editedDescription,
                { headers: { 'Content-Type': 'application/json' } }
            );
            setProduct({ ...product, descriptionProduct: editedDescription });
            setEditingProductId(null);
            alert('Descripción guardada correctamente');
        } catch (error) {
            console.error('Error updating product:', error);
            alert('Error guardando la descripción: ' + error);
        }
    };

    const handleCancel = () => {
        setEditingProductId(null);
    };

    if (!product) {
        return ciemId ? <p>Cargando producto...</p> : <p>Introduce un código de producto.</p>;
    }

    const handleShowModalInformacion = (content) => {
        setModalContentInformacion(content);
        setShowModalInformacion(true);
    };
    const handleCloseModalInformacion = () => setShowModalInformacion(false);
    const calificacion = <Ranked field={rankedForm} ciemId={ciemId} />


    return (
        <div className="container-fluid"> {/* Contenedor para ocupar todo el ancho */}
            {tituloProduct.map((itemE) => (
                <Card key={itemE.id}>

                    <Card.Header>
                        {itemE.description && (
                            <h1>
                                <Card.Title className="d-flex align-items-center gap-2">
                                    {itemE.description}
                                    {itemE.tooltip && (
                                        <Button
                                            variant="link"
                                            size="sm"
                                            className="p-0 text-info"
                                            onClick={() => handleShowModalInformacion(itemE.tooltip)}
                                            title="Ver información"
                                        >
                                            <FontAwesomeIcon icon={faInfoCircle} />
                                        </Button>
                                    )}
                                    {itemE.modal && (
                                        <Button
                                            variant="link"
                                            size="sm"
                                            className="p-0 ms-1"
                                            onClick={() => handleShowModalInformacion(itemE.modal)}
                                        >
                                            Más información
                                        </Button>
                                    )}
                                </Card.Title>
                            </h1>
                        )}
                    </Card.Header>
                    <Card.Body>
                        <Card.Title>Nombre idea de negocio : {product.name}</Card.Title>
                        <Card.Subtitle className="mb-2 text-muted">{product.code}</Card.Subtitle>
                        <Form>
                            <Form.Group className="mb-3">
                                <Form.Control
                                    as="textarea"
                                    rows={5} // Aumentar las filas para que sea más grande
                                    value={editedDescription}
                                    onChange={(e) => setEditedDescription(e.target.value)}
                                    maxLength={1000}
                                    style={{ width: '100%' }} // Ocupar el 100% del ancho
                                />
                            </Form.Group>
                            <Button variant="primary" onClick={handleSave}>Guardar</Button>
                        </Form>
                    </Card.Body>
                </Card>
            ))}
            <CardLayout value={"ciuuTitulo"} tablaComponent={tabla} />
            <CardLayout value={"rankedTwo"} tablaComponent={calificacion} />

            {/* Modal de información */}
            <Modal show={showModalInformacion} onHide={handleCloseModalInformacion} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Información</Modal.Title>
                </Modal.Header>
                <Modal.Body dangerouslySetInnerHTML={{ __html: modalContentInformacion }} />
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseModalInformacion}>
                        Cerrar
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default ProductList;